import { Box, Card, Rating, Stack, Typography, useTheme } from "@mui/material";
import { styled } from '@mui/material/styles';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { GetTheme, THEME } from "../../../theme/customThemeProvider";

const StyledRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#ff6d75',
  },
  '& .MuiRating-iconHover': {
    color: '#ff3d47',
  },
});

const TestimonialBox = ({client, fullWidth=false}) => {
    const theme = useTheme();
    const {themeMode} = GetTheme();

    return (
        <>
            <Card
                elevation={3}
                sx={{
                    width: fullWidth ? '100%' : '95%',
                    backgroundColor: theme.palette.background.default,
                    borderRadius: 8,
                    minHeight: {xs: 450, md: 450, lg: 400},
                    mt: 0.5,
                    mb: {xs: 3, md: 5},
                    ml: 1,
                    position: 'relative'
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='space-between'
                    alignItems='start'
                    p={{xs: 3, md: 5}}
                >
                    {
                        client.rating > 0
                        ?
                        <StyledRating
                            name="customized-color"
                            defaultValue={client.rating}
                            getLabelText={(value) => `${value} Heart${value !== 1 ? 's' : ''}`}
                            precision={0.5}
                            icon={<FavoriteIcon fontSize="inherit" />}
                            emptyIcon={<FavoriteBorderIcon fontSize="inherit" />}
                            readOnly
                            size="small"
                        />
                        :
                        <div></div>
                    }

                    <Typography
                        fontWeight={500}
                        fontSize={{xs: 12, md: 12, lg: 12}}
                        textAlign="left"
                        lineHeight={1.5}
                        color={theme.palette.text.secondary}
                        pt={3}
                    >
                        {client.description}
                    </Typography>

                    <Stack
                        direction='row'
                        justifyContent='start'
                        alignItems='center'
                        spacing={2}
                        pt={{xs: 2, md: 5}}
                        position='absolute'
                        bottom={40}
                    >
                        <Box
                            sx={{
                                width: {xs: 50, md: 80}
                            }}
                        >
                            <img 
                                src={client.profile}
                                alt={client.name} 
                                width='100%'
                                style={{
                                    borderRadius: '50%',
                                    aspectRatio: 1/1
                                }}
                            />
                        </Box>

                        <Stack
                            direction='column'
                            justifyContent='center'
                            alignItems='start'
                            spacing={0.5}
                        >
                            <Typography
                                fontWeight={600}
                                fontSize={{xs: 12, md: 14, lg: 16}}
                                textAlign='left'
                                color={theme.palette.text.primary}
                                lineHeight={1.25}
                            >
                                {client.name}
                            </Typography>

                            <Typography
                                fontWeight={500}
                                fontSize={12}
                                textAlign="left"
                                lineHeight={1.5}
                                color={theme.palette.text.secondary}
                            >
                                {client.role}
                            </Typography>

                            <Typography
                                fontWeight={600}
                                fontSize={10}
                                textAlign="left"
                                lineHeight={1.5}
                                color={theme.palette.text.secondary}
                            >
                                {client.country}
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Card>
        </>
    );
}

export default TestimonialBox;